<template>
  <div class="browser-shell" id="workspaceBrowserShell">
    <div class="browser-top">
      <div class="browser-dots">
        <span class="browser-dot red"></span>
        <span class="browser-dot yellow"></span>
        <span class="browser-dot green"></span>
      </div>
      <div class="browser-address" id="workspaceBrowserAddress">{{ browserAddress }}</div>
    </div>
    <div class="browser-page">
      <div
        class="browser-stage"
        id="workspaceBrowserStage"
        :class="{
          'scene-desktop': workspaceScene === 'desktop',
          'scene-processing': workspaceScene === 'processing',
          'scene-result': workspaceScene === 'result',
          'scene-google': workspaceScene === 'google',
          'scene-file': workspaceScene === 'file'
        }"
        ref="stage"
      >
        <!-- Desktop viewport -->
        <div class="desktop-home workspace-viewport" id="workspaceDesktopViewport">
          <div class="desktop-icons">
            <div class="desktop-icon"><div class="desktop-icon-mark">🌐</div><span>Google Chrome</span></div>
            <div class="desktop-icon"><div class="desktop-icon-mark">📁</div><span>项目文件</span></div>
            <div class="desktop-icon"><div class="desktop-icon-mark">📝</div><span>待办记录</span></div>
          </div>
          <div class="desktop-taskbar">
            <div class="taskbar-app">⊞</div>
            <div class="taskbar-app">🔍</div>
            <div class="taskbar-app">🌐</div>
            <div class="taskbar-app">📁</div>
            <div class="taskbar-app">💬</div>
            <div class="taskbar-time">17:08</div>
          </div>
        </div>

        <!-- Processing viewport -->
        <div class="processing-home workspace-viewport" id="workspaceProcessingViewport"></div>

        <!-- Result viewport -->
        <div class="result-home workspace-viewport" id="workspaceResultViewport"></div>

        <!-- File preview viewport -->
        <div class="file-preview-home" id="workspaceFileViewport" v-if="workspaceFile">
          <div class="file-preview-head">
            <span class="file-preview-filename">{{ workspaceFile.fileName }}</span>
            <a v-if="workspaceFile.url" :href="workspaceFile.url" download class="file-preview-download-btn">下载</a>
            <button class="file-preview-close" type="button" @click="closeFilePreview">✕</button>
          </div>
          <div class="file-preview-body">
            <template v-if="workspaceFile.kind === 'image'">
              <img :src="workspaceFile.url" class="file-preview-img" :alt="workspaceFile.fileName" />
            </template>
            <template v-else-if="workspaceFile.kind === 'video'">
              <video :src="workspaceFile.url" class="file-preview-video" controls></video>
            </template>
            <template v-else-if="workspaceFile.kind === 'audio'">
              <div class="file-preview-audio-wrap">
                <div class="file-preview-audio-label">{{ workspaceFile.fileName }}</div>
                <audio :src="workspaceFile.url" controls></audio>
              </div>
            </template>
            <template v-else>
              <template v-if="workspaceFile.mimeType === 'application/pdf'">
                <iframe :src="workspaceFile.url" class="file-preview-iframe"></iframe>
              </template>
              <template v-else>
                <div class="file-preview-doc-card">
                  <div class="file-preview-doc-icon">文</div>
                  <div class="file-preview-doc-info">
                    <div class="file-preview-doc-name">{{ workspaceFile.fileName }}</div>
                    <a v-if="workspaceFile.url" :href="workspaceFile.url" download class="file-preview-doc-download">点击下载</a>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>

        <!-- Google viewport -->
        <div class="google-home workspace-viewport" id="workspaceBrowserViewport">
          <div class="google-home-top">
            <a class="google-top-link" href="javascript:void(0)">Gmail</a>
            <a class="google-top-link" href="javascript:void(0)">Images</a>
            <div class="google-apps" aria-hidden="true">
              <span></span><span></span><span></span>
              <span></span><span></span><span></span>
              <span></span><span></span><span></span>
            </div>
            <div class="google-user-chip">G</div>
          </div>
          <div class="google-home-center">
            <div class="google-logo" aria-label="Google">
              <span class="g-blue">G</span><span class="g-red">o</span><span class="g-yellow">o</span><span class="g-blue">g</span><span class="g-green">l</span><span class="g-red">e</span>
            </div>
            <div class="google-search-shell">
              <span class="google-search-icon">
                <svg viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35m1.6-5.15a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
              <div class="google-search-query" id="workspaceBrowserTitle">{{ browserTitle }}</div>
              <span class="google-mic-icon">
                <svg viewBox="0 0 24 24" fill="none"><path d="M12 3a3 3 0 013 3v6a3 3 0 11-6 0V6a3 3 0 013-3zM19 11a7 7 0 01-14 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 18v3M8 21h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </div>
            <div class="google-actions">
              <button class="google-action" type="button">Google 搜索</button>
              <button class="google-action" type="button">手气不错</button>
            </div>
            <p class="google-search-hint" id="workspaceBrowserDesc">{{ browserDesc }}</p>
            <div class="browser-grid">
              <div class="browser-card">
                <div class="browser-card-title" id="workspaceBrowserCard1Title">{{ card1Title }}</div>
                <div class="browser-card-desc" id="workspaceBrowserCard1Desc">{{ card1Desc }}</div>
              </div>
              <div class="browser-card">
                <div class="browser-card-title" id="workspaceBrowserCard2Title">继续查找竞品与方案</div>
                <div class="browser-card-desc" id="workspaceBrowserCard2Desc">继续延伸查看竞品、对比文章与适用场景分析。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'WorkspaceBrowserShell',
  props: {
    fullscreen: { type: Boolean, default: false }
  },
  computed: {
    ...mapState(['workspaceScene', 'workspaceBrowserAddress', 'workspaceBrowserTitle', 'workspaceBrowserDesc', 'processingContent', 'workspaceFile']),
    browserAddress() { return this.workspaceBrowserAddress || '桌面' },
    browserTitle() { return this.workspaceBrowserTitle || '' },
    browserDesc() { return this.workspaceBrowserDesc || '' },
    card1Title() { return this.processingContent ? `搜索：${this.processingContent.progressTitle || ''}` : '' },
    card1Desc() { return this.processingContent ? this.processingContent.searchDesc || '' : '' }
  },
  mounted() {
    this.syncScale()
    window.addEventListener('resize', this.syncScale)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncScale)
  },
  methods: {
    ...mapMutations(['SET_WORKSPACE_SCENE', 'SET_WORKSPACE_FILE']),
    closeFilePreview() {
      this.SET_WORKSPACE_SCENE('desktop')
      this.SET_WORKSPACE_FILE(null)
    },
    syncScale() {
      const stage = this.$refs.stage
      if (!stage) return
      const w = stage.clientWidth
      const h = stage.clientHeight
      if (!w || !h) return
      const scale = Math.min(w / 1920, h / 1080)
      const viewport = stage.querySelector('#workspaceBrowserViewport')
      if (viewport) {
        viewport.style.transform = `translate(-50%, -50%) scale(${scale})`
      }
    }
  }
}
</script>
